interface Array<T> {
    /**
     * Returns a deep copy of a random element from the array.
     * If the array is empty, returns `undefined`.
     * 
     * The original array is not modified, and the returned element
     * is a deep-cloned copy (not a reference to the original).
     */
    randomDeepCopy(): T | undefined;
    /**
     * Returns a random element from the array.
     *
     * This method does not create a copy — it returns a reference to the original element.
     * Useful for selecting a random item without modifying the array.
     *
     * @returns A random element from the array, or undefined if the array is empty.
     */
    random(): T | undefined;
    /**
 * Shuffles the array in place using the Fisher–Yates algorithm.
 * 
 * The original array is modified, and the same instance is returned
 * for chaining.
 *
 * @returns The shuffled array (same instance).
 */
    shuffle(): T[];
}

Array.prototype.randomDeepCopy = function <T>(this: T[]): T | undefined {
    if (this.length === 0) return undefined;

    const randomIndex = Math.floor(Math.random() * this.length);
    const item = this[randomIndex];

    if (typeof structuredClone === 'function') {
        return structuredClone(item);
    } else {
        return JSON.parse(JSON.stringify(item)); // Fallback deep copy
    }
};

Array.prototype.random = function <T>(): T | undefined {
    if (this.length === 0) return undefined;
    return this[Math.floor(Math.random() * this.length)];
};

Array.prototype.shuffle = function <T>(this: T[]): T[] {
    for (let i = this.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [this[i], this[j]] = [this[j], this[i]];
    }
    return this;
};